// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IImageDto } from './image-dto.g';

export const logosDto = {
    logoDto: 'logoDto',
    logoThumbDto: 'logoThumbDto',
    logoEmailDto: 'logoEmailDto',
    logoIconPngDto: 'logoIconPngDto',
    logoIconSvgDto: 'logoIconSvgDto',
    logoFileBox_Guid: 'logoFileBox_Guid',
    folderShard: 'folderShard',
} as const;

export type TLogosDto = (typeof logosDto)[keyof typeof logosDto];

export interface ILogosDto {
    [logosDto.logoDto]: IImageDto | null;
    [logosDto.logoThumbDto]: IImageDto | null;
    [logosDto.logoEmailDto]: IImageDto | null;
    [logosDto.logoIconPngDto]: IImageDto | null;
    [logosDto.logoIconSvgDto]: IImageDto | null;
    [logosDto.logoFileBox_Guid]: string | null;
    [logosDto.folderShard]: string | null;
}

export class LogosDto
    implements ILogosDto
{
    [logosDto.logoDto]: IImageDto | null = null;
    [logosDto.logoThumbDto]: IImageDto | null = null;
    [logosDto.logoEmailDto]: IImageDto | null = null;
    [logosDto.logoIconPngDto]: IImageDto | null = null;
    [logosDto.logoIconSvgDto]: IImageDto | null = null;
    [logosDto.logoFileBox_Guid]: string | null = null;
    [logosDto.folderShard]: string | null = null;

    private constructor(
        modelData: any, // TODO: vervang door ILogosData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[logosDto.guid] = modelData[logosData.guid];
    }

    static create(modelData?: any | null): ILogosDto | null {
        return modelData ? new LogosDto(modelData) : null;
    }
}
